import { Component, OnInit } from '@angular/core';
import { DataManipulateService } from '../../services/data-manipulate.service';
import { ApiRequestsService } from '../../services/api-requests.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-default-sidebar',
  templateUrl: './default-sidebar.component.html',
  styleUrls: ['./default-sidebar.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
})
export class DefaultSidebarComponent implements OnInit {

  tempvariable: boolean = false;
  userRole: string = '';

  constructor(private data: DataManipulateService, private api: ApiRequestsService, private router: Router) { }
  ngOnInit(): void {
    this.userRole = this.data.userInfo['userrole'];
    console.log(this.api.getTokenValue());

  }

  isAdministrator = () => this.data.userInfo.userRole == 'Admin';
  isProjectManager = () => this.data.userInfo.isProjectManager;
  isOnlyTeamMember = () => this.data.userInfo.userRole !== 'Admin' && !this.data.userInfo.isProjectManager;

  showManageProjectsMenu = () => this.data.userInfo.isProjectManager || this.data.userInfo.userRole == 'Admin'

  showManageUsersMenu = () => this.data.userInfo.userRole == 'Admin'

  showManageHolidaysMenu = () => this.data.userInfo.userRole == 'Admin'

  goToPage(url: string) {
    debugger
    this.router.navigateByUrl(url);
  }

  togglemini() {
    document.body.classList.toggle('sidebar-mini');
  }

}
